/**
 * DescriptionImage component.
 */
import DeviceConfig from '@devices/config';
import PhotoDefault from '@shared/assets/images/png/photoDefault.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled description image.
 */
const DescriptionImage = styled.img<React.CSSProperties>`
  height: ${662 * Screen.widthRatio}px;
  width: ${1177 * Screen.widthRatio}px;
  position: absolute;
  right: 0;
  top: 0;
  ${() => {
    return DeviceConfig.capabilities?.image?.disableFitCover
      ? ''
      : 'object-fit:cover';
  }};
`;

export default withImage(DescriptionImage, true, PhotoDefault);
